import { render, staticRenderFns } from "./verifyEmailCard.vue?vue&type=template&id=6e4ee5b4&scoped=true"
import script from "./verifyEmailCard.vue?vue&type=script&lang=js"
export * from "./verifyEmailCard.vue?vue&type=script&lang=js"
import style0 from "./verifyEmailCard.vue?vue&type=style&index=0&id=6e4ee5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4ee5b4",
  null
  
)

export default component.exports